import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import Link from '@mui/material/Link';
import PostAddIcon from '@mui/icons-material/PostAdd';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { toast } from 'react-toastify';
import { formatNumber, defaultStringIfNullOrEmpty, toNumberWithNoDecimalPlaces } from '../Common/Utilities';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { InvoiceDocumentEditor } from './InvoiceDocumentEditor';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { Constants } from '../Common/Constants';
import { CircularProgress, MenuItem, Select, Paper, Typography } from '@mui/material';
import { MUIButton } from '../Common/Components/MuiButton';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import { getFilter, setFilter, getInvoiceModuleName, getFileIcon, getDisplayName } from '../Common/Utilities';
import ReplayIcon from '@mui/icons-material/Replay';
import IconButton from '@mui/material/IconButton';
import { downloadInvoiceFile } from '../Common/Utilities';
import DeleteIcon from '@mui/icons-material/Delete';
import InvoiceDocumentPartialPostLookup from '../Lookups/InvoiceDocumentPartialPostLookup';
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export default class InvoiceDocument extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			downloadingInvoices: {},
			hasLoadedOnce: false,
			data: [],
			showBulkPostToERP: false,
			openBulkDeleteConfirmation: false,
			selectedRows: [],
			openInvoiceDocumentEditorDialog: false,
			isServerMode: false,
			weeksToFilter: 9,
			filterText: '',
			sortModel: [],
			previousSearchText: "",
			noFilter: false,

			repostRuleEditable: false,
			deletePermission: false,
			postCreditMemo: false,

			activeRowId: null,        // row user opened details for
			loadingRowIds: [],       // rows currently refreshing (invoiceDocumentId list)
			pendingCreations: [],     // pending create items (shown above grid)

			// Partial repost/view-details dialog (list-level)
			openPartialPostDialog: false,
			partialPostInvoiceDocumentId: null,
			partialPostDialogMode: 'view', // 'view' | '' (edit)
			partialPostInvoiceId: null,
			partialSelectedRows: null,
			openCreditMemoRepostDialog: false,
			creditMemoRowForRepost: null,
			postPermission: false,

		};

		// Token used to ignore stale list responses when user changes filters quickly
		this.invoiceListFetchToken = 0;

		this.mainGridRef = React.createRef();

		this.dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
			timeZone: 'UTC',
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
			second: '2-digit',
			hour12: true,
		});

		this.dateFormatter = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' });

		const userInfo = JSON.parse(localStorage.userInfo);
		this.companyCode = userInfo.companyCode;
		this.userRoleId = userInfo.selectedUserRoles.userRoleId;

		this.newInvoice_clickHandler = this.newInvoice_clickHandler.bind(this);
		this.invoiceDocumentEditor_closeHandler = this.invoiceDocumentEditor_closeHandler.bind(this);
		this.fetchInvoiceDocuments = this.fetchInvoiceDocuments.bind(this);
		this.bulkPostToERP_clickHandler = this.bulkPostToERP_clickHandler.bind(this);
		this.getWeeksToFilterDropDown = this.getWeeksToFilterDropDown.bind(this);
		this.weeksToFilter_changeHandler = this.weeksToFilter_changeHandler.bind(this);
		this.getSearchButton = this.getSearchButton.bind(this);
		this.initializeFiltersFromStorage = this.initializeFiltersFromStorage.bind(this);
		this.delay = this.delay.bind(this);
		this.replaceInvoiceRowByFileKey = this.replaceInvoiceRowByFileKey.bind(this);

		this.fetchCreatedInvoiceAndInsert = this.fetchCreatedInvoiceAndInsert.bind(this);
		this.renderPendingCreations = this.renderPendingCreations.bind(this);
		this.getNextRowId = this.getNextRowId.bind(this);

		this.refreshRowViaListApi = this.refreshRowViaListApi.bind(this);
		this.fetchRepostRuleEditable = this.fetchRepostRuleEditable.bind(this);
		this.createColumns = this.createColumns.bind(this);

		// Keep column definitions stable so user-resized column widths don't reset
		// on any state updates (e.g., row reload/refresh).
		this.columns = this.createColumns(props);
	}

	componentDidUpdate(prevProps) {
		// Rebuild columns only when the shape can actually change.
		if (prevProps.modelDefId !== this.props.modelDefId) {
			this.columns = this.createColumns();
		}
	}

	isCreditMemoRow(row) {
		return Number(row?.applyToInvoiceDocumentId) > 0;
	}

	delay(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}



	addLoadingRows(ids) {
		const arr = (ids || []).filter(Boolean);
		if (arr.length === 0) return;
		this.setState((prev) => {
			const cur = prev.loadingRowIds || [];
			const next = Array.from(new Set([...cur, ...arr]));
			return { loadingRowIds: next };
		});
	}

	removeLoadingRows(ids) {
		const arr = (ids || []).filter(Boolean);
		if (arr.length === 0) return;
		this.setState((prev) => {
			const cur = prev.loadingRowIds || [];
			return { loadingRowIds: cur.filter((x) => !arr.includes(x)) };
		});
	}

	isRowLoading(invoiceDocumentId) {
		return (this.state.loadingRowIds || []).includes(invoiceDocumentId);
	}

	// A row is considered "Post In Progress" if either the list status or the post-status says so.
	isPostInProgressRow(row) {
		const postStatus = (row?.invoicePostStatus || '').toString().toLowerCase();
		const listStatus = (row?.status || '').toString().toLowerCase();
		return postStatus === 'post in progress' || listStatus === 'post in progress';
	}

	/**
		 * Replace flow:
		 * - After a successful "Replace" upload, the old invoice row may disappear server-side,
		 *   and the new invoice row may take a moment to become queryable.
		 * - We retry fetch-by-filename/fileLocation 3 times (2s delay by default).
		 * - If found, replace old row in-place; if not found, remove old row.
		 */
	async replaceInvoiceRowByFileKey(oldInvoiceDocumentId, fileKey, attempts = 3, delayMs = 2000) {
		if (!oldInvoiceDocumentId || !fileKey) return;

		// Keep the old row in loading state (spinner in Actions column) while we retry.
		this.addLoadingRows([oldInvoiceDocumentId]);

		const computeShowBulkPostToERP = (rows) => {
			const postToERPSystem = "Post to ERP System";
			const repostToERPSystem = "Repost to ERP System";
			const readyToPost = "Ready to Post";

			const invalidForPost = (rows || []).filter(x =>
				x.approvalLinkText !== postToERPSystem &&
				x.approvalLinkText !== repostToERPSystem &&
				x.approvalLinkText !== readyToPost
			);

			return (rows || []).length > 0 && invalidForPost.length === 0;
		};

		try {
			// Always wait before the first lookup (matches Vendor Invoice Report behavior).
			await this.delay(delayMs);

			const modelDefId = this.props.modelDefId;

			// Prefer the row's companyCode (in case list is multi-company), otherwise fallback to logged-in company.
			const oldRow = (this.state.data || []).find(r => r.invoiceDocumentId === oldInvoiceDocumentId);
			const companyCode = oldRow?.companyCode || this.companyCode;

			let newInvoiceDocumentId = null;
			let newRow = null;

			for (let i = 0; i < attempts; i++) {
				try {
					const uri =
						`/api/invoicedocument/invoicedocumenteditorbyfilename?invoiceDocumentFileLocation=${encodeURIComponent(fileKey)}` +
						(companyCode ? `&companyCode=${encodeURIComponent(companyCode)}` : '');

					const byFileRes = await httpGet(uri);
					const candidateId = byFileRes?.data?.invoiceDocumentId;

					// If backend still returns the old invoice, treat it as "not ready".
					if (candidateId && candidateId !== oldInvoiceDocumentId) {
						newInvoiceDocumentId = candidateId;

						let apiUrl = `/api/invoicedocument/${modelDefId}`;
						apiUrl += `?invoiceDocumentId=${newInvoiceDocumentId}`;
						apiUrl += `&searchFilter=${encodeURIComponent('')}`;
						apiUrl += `&weeksToFilter=${0}`;

						const listRes = await httpGet(apiUrl);
						newRow = listRes?.data?.[0] || null;

						if (newRow) break; // ✅ Success
					}
				} catch (e) {
					// swallow and retry
				}

				if (i < attempts - 1) {
					await this.delay(delayMs);
				}
			}

			if (!newInvoiceDocumentId || !newRow) {
				// After retries we still can't see the replaced invoice -> remove old row and notify user.
				this.setState((prev) => {
					const nextData = (prev.data || []).filter(r => r.invoiceDocumentId !== oldInvoiceDocumentId);
					const nextSelected = (prev.selectedRows || []).filter(r => r.invoiceDocumentId !== oldInvoiceDocumentId);
					const wasActive = prev.activeRowId === oldInvoiceDocumentId;

					return {
						data: nextData,
						selectedRows: nextSelected,
						showBulkPostToERP: computeShowBulkPostToERP(nextSelected),
						activeRowId: wasActive ? null : prev.activeRowId
					};
				});

				toast.warning('Replace is still in progress. Removed the old row - refresh later to see the new invoice.');
				return;
			}

			// ✅ Remove old row and insert the new row (with a NEW rowId based on the NEW invoiceDocumentId).
			this.setState((prev) => {
				const prevData = prev.data || [];
				const prevSelected = prev.selectedRows || [];

				const oldIndex = prevData.findIndex(r => r.invoiceDocumentId === oldInvoiceDocumentId);
				const dataWithoutOld = prevData.filter(r => r.invoiceDocumentId !== oldInvoiceDocumentId);
				const insertIndex = oldIndex === -1 ? dataWithoutOld.length : oldIndex;

				// Keep the old suffix (index) if rowId is like "invoiceId_index"
				let suffix = insertIndex;
				const oldRowLocal = prevData.find(r => r.invoiceDocumentId === oldInvoiceDocumentId);
				if (oldRowLocal?.rowId) {
					const parts = String(oldRowLocal.rowId).split('_');
					if (parts.length > 1) suffix = parts.slice(1).join('_');
				}

				const nextRowId = `${newInvoiceDocumentId}_${suffix}`;
				const nextRow = { ...newRow, rowId: nextRowId };

				const nextData = [
					...dataWithoutOld.slice(0, insertIndex),
					nextRow,
					...dataWithoutOld.slice(insertIndex)
				];

				const nextSelected = prevSelected.map(r =>
					r.invoiceDocumentId === oldInvoiceDocumentId ? nextRow : r
				);

				const wasActive = prev.activeRowId === oldInvoiceDocumentId;

				return {
					data: nextData,
					selectedRows: nextSelected,
					showBulkPostToERP: computeShowBulkPostToERP(nextSelected),
					activeRowId: wasActive ? newInvoiceDocumentId : prev.activeRowId
				};
			});
		} finally {
			// Stop spinner for the old row id (row might already be removed).
			this.removeLoadingRows([oldInvoiceDocumentId]);
		}
	}

	getNextRowId(rows) {
		try {
			if (!rows || rows.length === 0) return 0;
			const maxId = Math.max(...rows.map(r => (typeof r.rowId === 'number' ? r.rowId : -1)));
			return (isFinite(maxId) ? maxId + 1 : 0);
		} catch {
			return 0;
		}
	}

	renderPendingCreations() {
		const pending = this.state.pendingCreations || [];
		if (pending.length === 0) return null;

		return (
			<Paper elevation={0} style={{ padding: 10, margin: '10px 0 12px 0', border: '1px solid #e0e0e0' }}>
				<Typography variant="subtitle2" style={{ marginBottom: 6 }}>
					Pending creations
				</Typography>

				{pending.map((p) => (
					<div key={p.key} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0' }}>
						{p.status === 'pending' ? <CircularProgress size={16} /> : <ErrorIcon fontSize="small" />}

						<Typography variant="body2" style={{ flex: 1 }}>
							{(() => {
								const label = (p.entityLabel || 'Invoice').toString();
								const lower = label.toLowerCase();
								return p.invoiceDocumentId ? `Creating ${lower} #${p.invoiceDocumentId}...` : `Creating ${lower}...`;
							})()}
							{p.status === 'failed' && p.error ? ` (${p.error})` : ''}
						</Typography>

						{p.status === 'failed' && (
							<Link
								component="button"
								underline="always"
								onClick={() => this.fetchCreatedInvoiceAndInsert(p.invoiceDocumentId, 3, 2000, { entityLabel: p.entityLabel, insertAfterInvoiceDocumentId: p.insertAfterInvoiceDocumentId })}
							>
								Retry
							</Link>
						)}
					</div>
				))}
			</Paper>
		);
	}

	/**
	 * Create flow:
	 * - New invoices created in UserEntry may not immediately show in the list (and can be hidden by current grid filters).
	 * - We show a "Pending creations" strip ABOVE the grid and retry-fetch the created invoice row by invoiceDocumentId.
	 * - Once the row is available, we insert it into list data (it may still be hidden by filters — but user saw progress).
	 */
	async fetchCreatedInvoiceAndInsert(invoiceDocumentId, attempts = 3, delayMs = 2000, options = {}) {
		if (!invoiceDocumentId) return;

		const entityLabel = (options?.entityLabel || 'Invoice').toString();
		const insertAfterInvoiceDocumentId = options?.insertAfterInvoiceDocumentId || null;
		const suppressSuccessToast = !!options?.suppressSuccessToast;
		const suppressWarningToast = !!options?.suppressWarningToast;

		// mark as pending (or flip failed -> pending on retry)
		this.setState((prev) => {
			const existing = (prev.pendingCreations || []).find(x => x.invoiceDocumentId === invoiceDocumentId);
			const next = existing
				? (prev.pendingCreations || []).map(x =>
					x.invoiceDocumentId === invoiceDocumentId
						? { ...x, status: 'pending', error: null, entityLabel: x.entityLabel || entityLabel, insertAfterInvoiceDocumentId: x.insertAfterInvoiceDocumentId || insertAfterInvoiceDocumentId }
						: x
				)
				: [
					...(prev.pendingCreations || []),
					{ key: `create-${invoiceDocumentId}`, invoiceDocumentId, status: 'pending', startedAt: Date.now(), error: null, entityLabel, insertAfterInvoiceDocumentId }
				];
			return { pendingCreations: next };
		});

		// delay before first lookup (same UX as replace)
		await this.delay(delayMs);

		const modelDefId = this.props.modelDefId;
		let foundRow = null;

		for (let i = 0; i < attempts; i++) {
			try {
				let apiUrl = `/api/invoicedocument/${modelDefId}`;
				apiUrl += `?invoiceDocumentId=${invoiceDocumentId}`;
				apiUrl += `&searchFilter=${encodeURIComponent('')}`;
				apiUrl += `&weeksToFilter=${0}`;

				const res = await httpGet(apiUrl);
				foundRow = res?.data?.[0] || null;

				if (foundRow) break;
			} catch (e) {
				// swallow and retry
			}

			if (i < attempts - 1) {
				await this.delay(delayMs);
			}
		}

		if (!foundRow) {
			this.setState((prev) => ({
				pendingCreations: (prev.pendingCreations || []).map(x =>
					x.invoiceDocumentId === invoiceDocumentId
						? { ...x, status: 'failed', error: 'Not available yet' }
						: x
				)
			}));
			if (!suppressWarningToast) {
				toast.warning(`${entityLabel} created, but it is not available in the list yet. Click Retry.`);
			}
			return;
		}

		this.setState((prev) => {
			const exists = (prev.data || []).some(r => r.invoiceDocumentId === invoiceDocumentId);
			const nextRowId = `${invoiceDocumentId}_${(prev.data || []).length}`;

			// Insert location:
			// - default: top (index 0)
			// - when insertAfterInvoiceDocumentId is provided: directly after that row (if found)
			let insertIndex = 0;
			if (insertAfterInvoiceDocumentId) {
				let lastIdx = -1;
				for (let i = 0; i < (prev.data || []).length; i++) {
					if ((prev.data || [])[i]?.invoiceDocumentId === insertAfterInvoiceDocumentId) {
						lastIdx = i;
					}
				}
				insertIndex = lastIdx >= 0 ? lastIdx + 1 : 0;
			}

			return {
				data: exists
					? (prev.data || []).map(r => (r.invoiceDocumentId === invoiceDocumentId ? { ...foundRow, rowId: r.rowId } : r))
					: [
						...(prev.data || []).slice(0, insertIndex),
						{ ...foundRow, rowId: nextRowId },
						...(prev.data || []).slice(insertIndex)
					],
				pendingCreations: (prev.pendingCreations || []).filter(x => x.invoiceDocumentId !== invoiceDocumentId),
				activeRowId: prev.activeRowId, // keep current highlight
			};
		});

		if (!suppressSuccessToast) {
			toast.success(`${entityLabel} created successfully`);
		}
	}

	async componentDidMount() {
		await this.initializeFiltersFromStorage();
		this.fetchInvoiceDocuments(this.state.filterText, this.state.weeksToFilter, { showSpinner: true });

		const gridRef = this.mainGridRef?.current;
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([this.state.filterText]);
		}

		this.fetchRepostRuleEditable(this.companyCode, this.userRoleId, this.props.modelDefId);
	}

	initializeFiltersFromStorage() {
		return new Promise((resolve) => {
			const basePath = [getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceDocuments"];

			const weeks = getFilter([...basePath, "weeksToFilter"]);
			const searchText = getFilter([...basePath, "searchText"]) || '';
			const sortModel = getFilter([...basePath, "sortModel"]) || [];

			this.setState({
				weeksToFilter: weeks !== '' && weeks !== undefined && weeks !== null ? weeks : 9,
				filterText: searchText,
				previousSearchText: (weeks === 0 && searchText.trim() !== '') ? searchText : '',
				sortModel
			}, resolve);
		});
	}

	fetchInvoiceDocuments(search, weekToFilter, options = {}) {
		const modelDefId = this.props.modelDefId;
		const isNoFilter = weekToFilter === 0;

		// Show the global spinner on:
		// - initial page load (hasLoadedOnce === false)
		// - any caller that explicitly requests it (e.g., Weeks-to-Filter changes / No-Filter search)
		const showSpinner = (options && typeof options.showSpinner === 'boolean')
			? options.showSpinner
			: !this.state.hasLoadedOnce;

		const fetchToken = ++this.invoiceListFetchToken;

		if (showSpinner && this.props?.inProgress) {
			this.props.inProgress(true);
		}

		let apiUrl = `/api/invoicedocument/${modelDefId}`;
		apiUrl += `?searchFilter=${encodeURIComponent(isNoFilter ? (search || '') : '')}&weeksToFilter=${weekToFilter}`;

		httpGet(apiUrl)
			.then((response) => {
				if (fetchToken !== this.invoiceListFetchToken) return; // stale response

				const data = (response.data || []).map((e, i) => ({ ...e, rowId: `${e.invoiceDocumentId}_${i}` }));

				this.setState({
					data,
					noFilter: isNoFilter,
					hasLoadedOnce: true,
				}, () => {
					// Track the last server-search text used in No Filter mode (for UX purposes)
					if (isNoFilter && (search || '').trim() !== '' && this.state.previousSearchText !== search) {
						this.setState({ previousSearchText: search });
					}
				});
			})
			.catch((error) => {
				if (fetchToken !== this.invoiceListFetchToken) return; // stale response

				toast.error('An error occurred while fetching the records');
				console.error('Fetch error:', error);

				// Ensure initial-load spinner doesn't get stuck if the first request fails
				if (!this.state.hasLoadedOnce) {
					this.setState({ hasLoadedOnce: true });
				}
			})
			.finally(() => {
				if (fetchToken !== this.invoiceListFetchToken) return; // stale response

				if (showSpinner && this.props?.inProgress) {
					this.props.inProgress(false);
				}
			});
	}
	handleDownloadFile = (modelDefId, invoiceDocumentId, fileLocation) => {

		this.setState(prev => ({
			downloadingInvoices: {
				...prev.downloadingInvoices,
				[invoiceDocumentId]: true
			}
		}));

		downloadInvoiceFile(modelDefId, fileLocation)
			.catch((error) => {

				const isNotFoundError =
					error?.response?.status === 422 ||
					error?.message === 'FILE_NOT_FOUND';

				if (isNotFoundError) {
					toast.error('File not found.');
				} else {
					toast.error('Failed to download the file.');
				}
			})
			.finally(() => {

				this.setState(prev => {
					const next = { ...prev.downloadingInvoices };
					delete next[invoiceDocumentId];
					return { downloadingInvoices: next };
				});
			});
	};

	refreshRowViaListApi(invoiceDocumentId, { setActive = true } = {}, validationParams = {
		isCreditMemo: false
	}) {
		const modelDefId = this.props.modelDefId;

		this.addLoadingRows([invoiceDocumentId]);
		const prevRow = (this.state.data || []).find(e => e.invoiceDocumentId === invoiceDocumentId);
		let apiUrl = `/api/invoicedocument/${modelDefId}`;
		apiUrl += `?invoiceDocumentId=${invoiceDocumentId}`;
		apiUrl += `&searchFilter=${encodeURIComponent('')}`;
		apiUrl += `&weeksToFilter=${0}`;

		return httpGet(apiUrl)
			.then((res) => {
				const updatedRow = res.data?.[0];
				if (!updatedRow) return;

				this.setState((prev) => ({
					data: (prev.data || []).map((row) =>
						row.invoiceDocumentId === invoiceDocumentId
							? { ...updatedRow, rowId: row.rowId }
							: row
					),
					activeRowId: setActive ? invoiceDocumentId : prev.activeRowId,
				}));
				if (validationParams && validationParams?.isCreditMemo) {
					if (updatedRow && updatedRow.invoiceDocumentStatusId === 170
						&& ((prevRow?.invoiceDocumentStatusId !== 170 ||
							(prevRow?.invoiceDocumentStatusId === 170 && prevRow.invoicePostStatus === 'partial posted')
						))
						&& updatedRow.invoicePostStatus !== 'partial posted') {
						this.setState({
							openCreditMemoRepostDialog: true,
							creditMemoRowForRepost: updatedRow
						});
					}

				}
			})
			.catch(() => {
				toast.error('Failed to refresh invoice row');
			})
			.finally(() => {
				this.removeLoadingRows([invoiceDocumentId]);
			});
	}
	async bulkPostToERP_clickHandler() {

		const selectedRows = this.state.selectedRows || [];
		const ids = selectedRows.map(r => r.invoiceDocumentId).filter(Boolean);
		if (ids.length === 0) return;

		// ✅ Credit memo repost dialog trigger (list-level)
		const isSingle = selectedRows.length === 1;
		const selectedRow = isSingle ? selectedRows[0] : null;

		// credit memo condition: applyToInvoiceDocumentId > 0
		const isCreditMemo = isSingle && this.isCreditMemoRow(selectedRow);

		// SAME checks as button check (you already disable the button when not eligible)
		const hasInProgressSelection = (this.state.selectedRows || []).some(r => this.isRowLoading(r.invoiceDocumentId));
		const hasInvalidSelection = (this.state.selectedRows || []).some(r => r.invoiceDocumentStatusId === 170);



		if (ids.length > 20) {
			toast.error('Maximum 20 invoices can be bulk posted at a time.');
			return;
		}

		// show spinner on Details for selected rows
		if (isCreditMemo) {
			this.props.inProgress(true);
		}

		this.addLoadingRows(ids);

		let wasPosted = false;

		let successMsg = isCreditMemo ? 'Invoice posted' : 'Invoice(s) post request sent';
		let failureMsg = isCreditMemo ? 'Invoice post failed' : 'Invoice(s) posting failed';

		try {
			if (this.props.modelDefId === 3) {
				await this.postCreditMemo(ids, true);
			} else {
				await this.postToERP(ids, true);
			}
			wasPosted = true;
			toast.success(successMsg);
		} catch (e) {
			toast.error(failureMsg);
			// remove spinners if bulk post failed
			this.removeLoadingRows(ids);
		} finally {
		}

		// Refresh ONLY affected rows and keep selection
		if (wasPosted) {

			await Promise.all(ids.map(id => this.refreshRowViaListApi(id, { setActive: false }, {
				isCreditMemo: isCreditMemo,
				hasInvalidSelection: hasInvalidSelection
			})));

		}
		this.props.inProgress(false);
	}


	async postSingleInvoice(creditMemoId) {
		if (this.props.modelDefId === 3) {
			await this.postCreditMemo([creditMemoId],);
		} else {
			await this.postToERP([creditMemoId]);
		}
	}

	postToERP(data, isCreditInvoice) {
		let url = "/api/adapter/postinvoices/";
		if (isCreditInvoice) {
			url += "?isSync=true";
		}
		return httpPost(url, data);
	}

	postCreditMemo(data, isCreditInvoice) {
		let url = "/api/invoicedocument/postcreditmemo/";
		if (isCreditInvoice) {
			url += "?isSync=true";
		}
		return httpPost(url, data);
	}

	bulkDeleteYes = () => {
		const ids = (this.state.selectedRows || []).map(r => r.invoiceDocumentId).filter(Boolean);
		// Close dialog immediately on Yes click (requested UX)
		this.setState({ openBulkDeleteConfirmation: false });

		if (ids.length === 0) {
			return;
		}

		// show spinner on Details for selected rows
		this.addLoadingRows(ids);

		httpPost('/api/invoicedocument/bulkdelete', ids)
			.then(() => {
				toast.success('Invoice(s) deleted successfully');
				this.setState((prev) => ({
					selectedRows: [],
					data: (prev.data || []).filter(row => !ids.includes(row.invoiceDocumentId))
				}));
			})
			.catch(() => {
				toast.error('Bulk delete failed');
			})
			.finally(() => {
				this.removeLoadingRows(ids);
			});
	};

	fetchRepostRuleEditable(companyCode, userRoleId, modelDefId) {
		httpGet(`/api/usergrouprules/${companyCode}/${userRoleId}`)
			.then((res) => {
				const rules = res.data || [];
				const repostRule = rules.find(r =>
					r.label === 'Repost Invoice' &&
					r.Model_def_id === modelDefId &&
					r.editable === '1'
				);
				const editRule = rules.find(r =>
					r.label === 'Delete Invoice' &&
					r.Model_def_id === modelDefId &&
					r.editable === '1'
				);
				const creditMemo = rules.find(r =>
					r.label === 'Post Credit Memo' &&
					r.Model_def_id === modelDefId &&
					r.editable === '1'
				);
				this.setState({ repostRuleEditable: !!repostRule, deletePermission: !!editRule, postCreditMemo: !!creditMemo });
			})
			.catch(() => {
				this.setState({ repostRuleEditable: false });
			});
	}

	newInvoice_clickHandler() {
		// Always clear partialSelectedRows and set mode to UserEntry
		this.setState({ openInvoiceDocumentEditorDialog: true, mode: "UserEntry", rowData: null, partialSelectedRows: null });
	}

	invoiceDocumentEditor_closeHandler({
		event,
		isRoutedToEmployeeOrApproval = false,
		wasUpdate = false,
		updatedRowFieldsData = null,
		responseObject = null,
		invoiceDocumentId = null,
		wasDelete = false,
		isCompanyChanged = false,
		isAvailableForRescaning = false,
		applyToInvoiceDocumentId = null
	}) {

		const closingMode = this.state.mode;
		const closingRowData = this.state.rowData;

		this.setState({ openInvoiceDocumentEditorDialog: false, rowData: null }, () => {
			// Credit memo reopen flow (preserve original behavior)
			if (responseObject?.invoiceIndicator === 2) {
				this.setState({
					openInvoiceDocumentEditorDialog: true,
					mode: Constants.CREDIT_MEMO,
					rowData: responseObject
				});
			}
			else if (
				responseObject?.openLinkedInvoice === true &&
				responseObject?.invoiceDocumentId
			) {
				const isCreditMemo = responseObject.invoiceIndicator === 2;

				this.setState({
					openInvoiceDocumentEditorDialog: true,
					mode: isCreditMemo ? Constants.CREDIT_MEMO : Constants.VIEW,
					rowData: {
						invoiceDocumentId: responseObject.invoiceDocumentId
					},
					isViaQueryString: false
				});

				return;
			}
			else if (responseObject?.operation === 'creditMemo' && invoiceDocumentId) {
				// ✅ Credit memo created from a posted invoice:
				// 1) refresh the source invoice row
				// 2) fetch + insert the newly created credit memo row
				// 3) if credit memo was posted, show rescan dialog
				const sourceInvoiceDocumentId = closingRowData?.invoiceDocumentId || null;
				if (sourceInvoiceDocumentId) {
					this.refreshRowViaListApi(sourceInvoiceDocumentId);
				}
				this.fetchCreatedInvoiceAndInsert(invoiceDocumentId, 3, 2000, {
					entityLabel: 'Credit memo',
					insertAfterInvoiceDocumentId: sourceInvoiceDocumentId,
					suppressSuccessToast: true
				});

				if (isAvailableForRescaning) {
					this.setState({
						openCreditMemoRepostDialog: true,
						creditMemoRowForRepost: {
							invoiceDocumentId: invoiceDocumentId,
							applyToInvoiceDocumentId: applyToInvoiceDocumentId || sourceInvoiceDocumentId
						}
					});
				}
			}
			else if (isCompanyChanged && invoiceDocumentId) {
				// Company change flow: invoice moved to a different company - remove it from the current list.
				this.setState((prev) => ({
					data: prev.data.filter((row) => row.invoiceDocumentId !== invoiceDocumentId),
					loadingRowIds: (prev.loadingRowIds || []).filter(x => x !== invoiceDocumentId),
					activeRowId: null
				}));
			}
			else if (wasDelete && invoiceDocumentId) {
				// Delete flow: remove row from list
				this.setState((prev) => ({
					data: prev.data.filter((row) => row.invoiceDocumentId !== invoiceDocumentId),
					loadingRowIds: (prev.loadingRowIds || []).filter(x => x !== invoiceDocumentId),
					activeRowId: null
				}));
			}
			else if (responseObject?.operation === 'replace' && invoiceDocumentId) {
				// Replace flow: retry fetch the new invoice by file key; replace old row if found, else remove old row.
				const fileKey = responseObject.invoiceDocumentFileLocation || responseObject.fileName;
				this.replaceInvoiceRowByFileKey(invoiceDocumentId, fileKey, 3, 2000);
			}
			else if (closingMode === "UserEntry" && !closingRowData && invoiceDocumentId) {
				// Create flow: show pending item above grid and retry-fetch the created invoice row
				this.fetchCreatedInvoiceAndInsert(invoiceDocumentId, 3, 2000);
			}
			else if (wasUpdate && invoiceDocumentId) {
				// Update flow: refresh row from list API
				if (isAvailableForRescaning) {
					this.props.inProgress(true);
				}
				this.refreshRowViaListApi(invoiceDocumentId, {}, {
					isCreditMemo: isAvailableForRescaning
				})
					.finally(() => {
						this.props.inProgress(false);
					});
			}

		});
	}

	getInvoiceSourceDisplay(invoiceSource) {
		return invoiceSource === 1 ? "EDI" : "PDF";
	}

	// Kept because editor uses it via info.repostInfo (existing behavior)
	getRepostAbility(rowData) {
		const status = (rowData?.invoicePostStatus || '').toString().toLowerCase();
		const isEligible = status === 'partial posted' || status === 'fully posted';
		const total = Number(rowData?.totalNumberInvoice);
		const posted = Number(rowData?.postedNumberInvoice);

		if (!isEligible || total === 0) return null;

		// Fully Posted
		if (posted == total) {
			return { dataMode: 'ViewDetails', shouldDisplay: true };
		}

		// Partially Posted
		if (posted < total) {
			return {
				dataMode: 'PartialPost',
				shouldDisplay: true,
				canRepost: !!this.state.repostRuleEditable,
			};
		}

		return { dataMode: null, shouldDisplay: true };
	}


	isPartiallyPostedRow(rowData) {
		const status = (rowData?.invoicePostStatus || '').toString().toLowerCase();
		if (status !== 'partial posted') return false;
		const total = Number(rowData?.totalNumberInvoice);
		const posted = Number(rowData?.postedNumberInvoice);
		return isFinite(total) && isFinite(posted) && total > 0 && posted < total;
	}

	openPartialPostDialogForRow(rowData) {
		const invoiceDocumentId = rowData?.invoiceDocumentId;
		if (!invoiceDocumentId) return;
		this.setState({
			activeRowId: invoiceDocumentId,
			openPartialPostDialog: true,
			partialPostInvoiceDocumentId: invoiceDocumentId,
			partialPostDialogMode: this.state.repostRuleEditable ? '' : 'view',
		});
	}

	openInvoiceDetails = (rowData) => {
		this.setState({
			activeRowId: rowData.invoiceDocumentId,
			openInvoiceDocumentEditorDialog: true,
			mode: Constants.VIEW,
			rowData: {
				invoiceDocumentId: rowData.invoiceDocumentId,
				invoiceSource: rowData.invoiceSource
			}
		});
	};

	// (Action column removed) — view is now on row click; reload moved to Status column.

	getWeeksToFilterDropDown(searchFilter) {
		const selectedValue = Number(this.state["weeksToFilter"] ?? 0);

		return (
			<Select
				variant="standard"
				sx={{
					float: "right",
					zIndex: 1,
					mt: 1.25,
					mr: 1.25,
					width: 100,
					backgroundColor: "rgba(0, 140, 205, 0.12)",
					"&.Mui-focused": {
						backgroundColor: "rgba(0, 140, 205, 0.12)",
					},
				}}
				value={selectedValue}
				onChange={(e) => {
					this.weeksToFilter_changeHandler({
						e: { ...e },
						target: { ...e.target },
						currentTarget: { dataset: { searchFilter: searchFilter } }
					});
				}}
			>
				<MenuItem value={0}>No Filter</MenuItem>
				<MenuItem value={1}>1 Week</MenuItem>
				<MenuItem value={2}>2 Weeks</MenuItem>
				<MenuItem value={4}>5 Weeks (1 Month)</MenuItem>
				<MenuItem value={9}>9 Weeks (2 Months)</MenuItem>
				<MenuItem value={26}>26 Weeks (6 Months)</MenuItem>
				<MenuItem value={52}>52 Weeks (1 Year)</MenuItem>
			</Select>
		);
	}

	weeksToFilter_changeHandler(event) {
		const basePath = [getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceDocuments"];

		const weeksToFilter = parseInt(event.target.value, 10);
		const isNoFilter = weeksToFilter === 0;
		const text = (this.state.filterText || '').trim();

		// CASE 1: Non-zero weeks – normal behavior
		if (!isNoFilter) {
			setFilter([...basePath, "weeksToFilter"], weeksToFilter);
			setFilter([...basePath, "searchText"], text);

			this.setState({
				weeksToFilter,
				isServerMode: false
			}, () => {
				this.mainGridRef.current?.setQuickFilterValues([this.state.filterText]);
				this.fetchInvoiceDocuments(this.state.filterText, weeksToFilter, { showSpinner: true });
			});
			return;
		}

		// CASE 2a: Switch TO No Filter (0) AND there IS search text → server mode + persist
		if (isNoFilter && text) {
			setFilter([...basePath, "weeksToFilter"], 0);
			setFilter([...basePath, "searchText"], text);

			this.setState({
				weeksToFilter: 0,
				isServerMode: true
			}, () => {
				this.mainGridRef.current?.setQuickFilterValues([text]);
				this.fetchInvoiceDocuments(text, 0, { showSpinner: true });
			});
			return;
		}

		// CASE 2b: Switch TO No Filter (0) and NO text → no server call, no storage change
		if (isNoFilter && !text) {
			this.setState({
				weeksToFilter: 0,
				isServerMode: true
			}, () => {
				this.mainGridRef.current?.setQuickFilterValues(['']);
			});
			return;
		}
	}


	openEditorFromRow(rowData, { modeOverride, partialSelectedRows } = {}) {
		if (!rowData?.invoiceDocumentId) return;

		this.setState({
			activeRowId: rowData.invoiceDocumentId,
			openInvoiceDocumentEditorDialog: true,
			mode: modeOverride ?? Constants.VIEW,
			rowData: {
				invoiceDocumentId: rowData.invoiceDocumentId,
				invoiceSource: rowData.invoiceSource
			},
			partialSelectedRows: partialSelectedRows ?? null
		});
	}

	getSearchButton() {
		if (this.state.weeksToFilter === 0) {
			return (
				<MUIButton
					color="primary"
					size="medium"
					startIcon={<SearchIcon />}
					sx={{
						backgroundColor: '#008ecd',
						border: '1px solid #008ecd',
						borderRadius: '6px',
						color: 'white !important',
						fontSize: '0.8rem !important',
						fontFamily: 'Lato, sans-serif',
						cursor: 'pointer',
						marginTop: '10px',
						marginRight: '14px',
						marginLeft: '1px',
						marginBottom: '0px',
						paddingTop: '4px',
						paddingBottom: '5px',
						paddingLeft: '11px',
						paddingRight: '9px',
						width: '100px',
						textTransform: 'none',
						'&:hover': {
							backgroundColor: '#007cb5',
							borderColor: '#007cb5',
						}
					}}
					text="Search"
					onClick={() => {
						const text = this.state.filterText || '';

						if (!text.trim()) {
							toast.error("Please enter search text first");
							return;
						}

						const basePath = [getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceDocuments"];

						setFilter([...basePath, "searchText"], text);
						setFilter([...basePath, "weeksToFilter"], this.state.weeksToFilter);

						this.setState(
							{
								previousSearchText: text,
								isServerMode: true
							},
							() => {
								this.fetchInvoiceDocuments(text, this.state.weeksToFilter, { showSpinner: true });
							}
						);
					}}
				/>
			);
		}

		return null;
	}

	setFilterText(text) {
		const isNoFilter = this.state.weeksToFilter === 0;
		const prevText = this.state.filterText;

		this.setState({ filterText: text, ...(text !== prevText && { previousSearchText: '' }) });

		const basePath = [getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceDocuments"];

		const shouldFilterPersist = (
			(text !== '' && !isNoFilter) || (prevText === text && text !== '' && isNoFilter)
		);

		if (shouldFilterPersist) {
			setFilter([...basePath, "searchText"], text);
			setFilter([...basePath, "weeksToFilter"], this.state.weeksToFilter);
		} else {
			setFilter([...basePath, "searchText"], '');
			setFilter([...basePath, "weeksToFilter"], '');
		}
	}

	createColumns(pageProps) {
		const modelDefId = this.props?.modelDefId || pageProps.modelDefId;

		return [
			...(modelDefId !== 3 ? [
				{
					headerName: 'File Name',
					field: 'fileName',
					flex: 1,
					minWidth: 220,
					renderCell: (rowData) => {
						const { invoiceDocumentId, invoiceDocumentFileLocation, fileName } = rowData.row;
						const isDownloading = this.state.downloadingInvoices[invoiceDocumentId];

						if (isDownloading) {
							return (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										width: '100%',
										height: '100%',
									}}
								>
									<CircularProgress size={18} />
								</div>
							);
						}

						if (!invoiceDocumentFileLocation) {
							return (
								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										display: 'block',
									}}
									title={fileName}
								>
									{fileName || ''}
								</span>
							);
						}

						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 8,
									width: '100%',
									overflow: 'hidden',
								}}
							>
								<span
									role="button"
									tabIndex={0}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
										flexShrink: 0,
									}}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
										this.handleDownloadFile(
											this.props.modelDefId,
											invoiceDocumentId,
											invoiceDocumentFileLocation
										);
									}}
								>
									<Tooltip title="View">
										{getFileIcon(invoiceDocumentFileLocation)}
									</Tooltip>
								</span>

								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										maxWidth: '100%',
										display: 'block',
									}}
									title={fileName}
								>
									{fileName}
								</span>
							</div>
						);
					}

				}
			] : []),
			...(this.props.modelDefId === 3 ? [
				{
					headerName: 'Source',
					field: 'invoiceSource',
					flex: 1,
					renderCell: rowData => this.getInvoiceSourceDisplay(rowData.row.invoiceSource)
				}
			] : []),
			...(this.props.modelDefId === 3 ? [
				{
					headerName: 'Media Type',
					field: 'mediaType',
					flex: 1
				}
			] : []),
			{
				headerName: 'Processed Date',
				field: 'dateUpdated',
				type: 'datetime',
				minWidth: 100,
				valueGetter: ({ value }) => (value ? new Date(value) : null),
				valueFormatter: ({ value }) => value
					? this.dateTimeFormatter.format(value)
					: '',
				flex: 1
			},
			...(this.props.modelDefId !== 3 ? [
				{
					headerName: 'Client',
					field: 'clientNameCode',
					//flex: 1,
					minWidth: 100,
					renderCell: rowData => {
						const rawValue = rowData.row.clientNameCode || '';
						const clients = rawValue.split('|').filter(c => c.trim());
						const tooltipText = rawValue;
						const displayText = clients.length > 1 ? `${clients[0]}...` : clients[0];

						return (
							<Tooltip
								title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipText}</span>}
								placement="top"
								arrow
							>
								<span style={{
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									display: 'block',
									maxWidth: '100%',
									fontSize: '0.75rem',
									width: '100%'
								}}
								>
									{displayText}
								</span>
							</Tooltip>
						);
					}
				}
			] : []),
			...(modelDefId === 3 ? [
				{
					headerName: 'Advertiser/Product',
					field: 'advertiserProduct',
					flex: 1,
					minWidth: 100,
					renderCell: (params) => (
						<Tooltip title={params.value || ''} arrow>
							<span
								style={{
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									display: 'block',
									width: '100%',
								}}
							>
								{params.value}
							</span>
						</Tooltip>
					),
				},
				{
					headerName: 'Contract Number',
					field: 'contractNumber',
					width: 130,
					renderCell: (params) => (
						<Tooltip title={params.value || ''} arrow>
							<span
								style={{
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									display: 'block',
									width: '100%',
								}}
							>
								{params.value}
							</span>
						</Tooltip>
					),
				}
			] : []),
			...(modelDefId !== 3 ? [
				{
					headerName: 'ERP Vendor/Site',
					field: 'vendor',
					flex: 1,
					minWidth: 100,
					renderCell: (params) => (
						<Tooltip title={params.value || ''} arrow>
							<span
								style={{
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									display: 'block',
									width: '100%',
								}}
							>
								{params.value}
							</span>
						</Tooltip>
					),
				}
			] : []),
			...(modelDefId === 3 ? [
				{
					headerName: 'Vendor',
					field: 'payTo',
					flex: 1,
					minWidth: 100,
					renderCell: (params) => (
						<Tooltip title={params.value || ''} arrow>
							<span
								style={{
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									display: 'block',
									width: '100%',
								}}
							>
								{params.value}
							</span>
						</Tooltip>
					),
				}
			] : []),
			{
				headerName: 'Status',
				field: 'status',
				minWidth: 140,
				renderCell: (rowData) => {
					const row = rowData.row;
					const invoiceId = row?.invoiceDocumentId;
					const isPostInProgress = this.isPostInProgressRow(row);
					const isLoading = !!invoiceId && this.isRowLoading(invoiceId);
					const showError = row?.invoiceDocumentStatusId === 180;

					const hasTrailingAction = isLoading || isPostInProgress || showError;

					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								width: '100%',
								gap: hasTrailingAction ? 6 : 0, // 👈 no dead space
							}}
						>
							{/* Status text with wrapping + tooltip */}
							<Tooltip title={row?.postedUserName ? `${row?.status} By: ${row.postedUserName}` : row?.status || ''} placement="top-start">
								<span
									style={{
										flex: 1,
										display: '-webkit-box',
										WebkitLineClamp: 2,
										WebkitBoxOrient: 'vertical',
										overflow: 'hidden',
										wordBreak: 'break-word',
										lineHeight: 1.3,
										cursor: 'default',
									}}
								>
									{row?.status}
								</span>
							</Tooltip>

							{/* Spinner — only when loading */}
							{isLoading && (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										flexShrink: 0,
									}}
								>
									<CircularProgress size={18} />
								</div>
							)}

							{/* Reload button */}
							{isPostInProgress && !isLoading && (
								<Tooltip title="Reload">
									<IconButton
										size="small"
										onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
											this.setState(
												{ activeRowId: invoiceId },
												() => this.refreshRowViaListApi(invoiceId)
											);
										}}
										aria-label="Reload"
									>
										<ReplayIcon fontSize="small" />
									</IconButton>
								</Tooltip>
							)}

							{/* Error icon */}
							{showError && (
								<Tooltip title={row?.invoiceDocumentPostingErrorMessage || ''}>
									<ErrorIcon
										color="secondary"
										onClick={(e) => e.stopPropagation()}
										style={{ flexShrink: 0 }}
									/>
								</Tooltip>
							)}
						</div>
					);
				},

				flex: 1
			},
			{
				headerName: 'Invoice #',
				field: 'invoiceNumber',
				flex: 1,
				minWidth: 120,
				renderCell: (params) => (
					<Tooltip title={params.value || ''} arrow>
						<span
							style={{
								display: 'block',
								whiteSpace: 'normal',
								wordBreak: 'break-all',
								overflowWrap: 'break-word',
								width: '100%',
								lineHeight: 1.4,
							}}
						>
							{params.value}
						</span>
					</Tooltip>
				),
			},
			{
				headerName: getDisplayName('User Status'),
				field: 'invoiceUserStatus',
				flex: 1,
				minWidth: 100,
				renderCell: (params) => (
					<Tooltip title={params.value || ''} arrow>
						<span
							style={{
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								display: 'block',
								width: '100%',
							}}
						>
							{params.value}
						</span>
					</Tooltip>
				),
			},
			...(modelDefId === 3 ? [
				{
					headerName: 'Total Spots',
					field: 'totalSpot',
					type: 'number',
					align: 'right',
					headerAlign: 'right',
					renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{toNumberWithNoDecimalPlaces(rowData.row.totalSpot)}</span>,
					flex: 1
				}
			] : []),
			{
				headerName: 'Net Amount',
				field: 'netAmount',
				type: 'currency',
				align: 'right',
				headerAlign: 'right',
				minWidth: 100,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.netAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
				flex: 1
			},
			{
				headerName: 'Tax Amount',
				field: 'taxAmount',
				type: 'currency',
				align: 'right',
				headerAlign: 'right',
				minWidth: 100,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.taxAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
				flex: 1
			},
			{
				headerName: 'Total Invoice Amount',
				field: 'totalAmount',
				type: 'currency',
				align: 'right',
				headerAlign: 'right',
				minWidth: 100,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.totalAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
				flex: 1
			},
			{
				headerName: 'Due Date',
				field: 'dueDate',
				type: 'date',
				minWidth: 100,
				valueGetter: ({ value }) => value || '',
				valueFormatter: ({ value }) => {
					if (!value) return '';
					const d = new Date(value);
					return this.dateFormatter.format(d);
				},
				flex: 1
			},
			...(modelDefId === 3 ? [
				{
					headerName: 'Invoice Date',
					field: 'invoiceDate',
					type: 'date',
					minWidth: 100,
					valueGetter: ({ value }) => value || '',
					valueFormatter: ({ value }) => {
						if (!value) return '';
						const d = new Date(value);
						return this.dateFormatter.format(d);
					},
					flex: 1
				}
			] : []),
			{
				headerName: 'Modify Date',
				field: 'modifyDate',
				type: 'date',
				minWidth: 100,
				valueGetter: ({ value }) => value || '',
				valueFormatter: ({ value }) => {
					if (!value) return '';
					const d = new Date(value);
					return this.dateFormatter.format(d);
				},
				flex: 1
			},
			...(modelDefId !== 3 ? [
				{
					headerName: 'Transaction Id',
					field: 'transactionId',
					flex: 1,
					minWidth: 120,
					renderCell: (params) => (
						<Tooltip title={params.value || ''} arrow>
							<span
								style={{
									display: 'block',
									whiteSpace: 'normal',
									wordBreak: 'break-all',
									overflowWrap: 'break-word',
									width: '100%',
									lineHeight: 1.4,
								}}
							>
								{params.value}
							</span>
						</Tooltip>
					),
				}
			] : []),
			...(modelDefId === 3 ? [
				{
					headerName: 'File Name',
					field: 'invoiceDocumentFileLocation',
					minWidth: 120,
					renderCell: (rowData) => {
						const { invoiceDocumentId, invoiceDocumentFileLocation, fileName, invoiceDocumentFileLocationEdiPdf, invoiceSource } = rowData.row;
						const isDownloading = this.state.downloadingInvoices[invoiceDocumentId];

						const isEdiPdf =
							Number(invoiceSource) === 1 &&
							!!invoiceDocumentFileLocationEdiPdf;

						const effectiveFileLocation = isEdiPdf
							? invoiceDocumentFileLocationEdiPdf
							: invoiceDocumentFileLocation;

						const displayFileName =
							fileName ||
							(effectiveFileLocation ? effectiveFileLocation.split(/[\\/]/).pop() : '');

						if (isDownloading) {
							return (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										width: '100%',
										height: '100%',
									}}
								>
									<CircularProgress size={18} />
								</div>
							);
						}

						if (!effectiveFileLocation) {
							return (
								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										display: 'block',
									}}
									title={displayFileName}
								>
									{displayFileName || ''}
								</span>
							);
						}

						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: 8,
									width: '100%',
									overflow: 'hidden',
								}}
							>
								<span
									role="button"
									tabIndex={0}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
										flexShrink: 0,
									}}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
										this.handleDownloadFile(
											this.props.modelDefId,
											invoiceDocumentId,
											effectiveFileLocation
										);
									}}
								>
									<Tooltip title="View">
										{getFileIcon(effectiveFileLocation)}
									</Tooltip>
								</span>

								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										maxWidth: '100%',
										display: 'block',
									}}
									title={displayFileName}
								>
									{displayFileName}
								</span>
							</div>
						);
					},



					//valueGetter: ({ value, row }) => {
					//	if (value?.toLowerCase().indexOf('.pdf') === -1) {
					//		return value;
					//	}
					//	else {
					//		return row.fileName;
					//	}
					//},
					flex: 1
				}
			] : [])
			// (Actions column removed) — row click performs view; reload/spinner are in Status.
		];
	}
	bulkPostButtonDisabled({ isInprogressState = false }) {
		if (isInprogressState) {
			return true;
		}

	}
	render() {
		const selectedRows = this.state.selectedRows || [];

		const isSingleSelection = selectedRows.length === 1;
		const selectedRow = isSingleSelection ? selectedRows[0] : null;

		const isCreditMemoSelected =
			isSingleSelection &&
			this.isCreditMemoRow(selectedRow);




		const info = {
			rowData: this.state.rowData,
			mode: this.state.mode,
			source: this.state.rowData?.invoiceSource,
			inProgress: this.props.inProgress,
			modelDefId: this.props.modelDefId,
			editorSource: (this.state.mode === "UserEntry" ? "" : Constants.INVOICE_LIST_SOURCE),
			repostInfo: this.getRepostAbility(this.state.rowData)
		};

		const clientInfo = {
			rowData: this.state.rowData,
			mode: this.state.mode,
			modelDefId: this.props.modelDefId,
			inProgress: this.props.inProgress
		};

		const serverProps = this.state.isServerMode ? { filterMode: 'server' } : {};

		const text = this.state.filterText;
		const prev = this.state.previousSearchText;
		const weeks = this.state.weeksToFilter;

		const isWeeksToFilterSearchActive =
			(text !== '' && weeks !== 0) ||
			(weeks === 0 && text === prev && text.trim() !== '');



		const hasInvalidSelection = (this.state.selectedRows || []).some(r => {
			if (r.invoiceDocumentStatusId === 180 && Number(r.applyToInvoiceDocumentId) > 0) {
				return false; // allow deletion
			}
			return r.invoiceDocumentStatusId === 170
				|| r.invoiceDocumentStatusId === 180
				|| r.invoiceDocumentStatusId === 175
				|| (r.status === "Ready to Post" && r.applyToInvoiceDocumentId <= 0)
		});

		const hasInProgressSelection = (this.state.selectedRows || []).some(r => this.isRowLoading(r.invoiceDocumentId));



		return (
			<div>
				<h1>Manage {this.props.modelDefId === 1 ? 'Media' : (this.props.modelDefId === 2 ? 'Production' : 'Broadcast')} Invoice Documents</h1>

				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>

						<div style={{
							display: 'flex',
							position: 'absolute',
							padding: '16px 10px 10px 10px',
							overflow: 'hidden',
							direction: 'row',
							zIndex: 1
						}}>
							{(this.state.postCreditMemo || this.state.repostRuleEditable) && <Button
								variant="contained"
								color="inherit"
								disabled={!this.state.showBulkPostToERP || hasInProgressSelection}
								onClick={this.bulkPostToERP_clickHandler}
								size="medium"
								startIcon={<SendIcon />}
							>
								Bulk Post to ERP System
							</Button>}

							{this.state.deletePermission && <Button
								variant="contained"
								color="inherit"
								size="medium"
								disabled={
									!this.state.selectedRows ||
									this.state.selectedRows.length === 0 ||
									hasInvalidSelection || hasInProgressSelection
								}
								style={{ marginLeft: '4px' }}
								onClick={() => this.setState({ openBulkDeleteConfirmation: true })}
								startIcon={<DeleteIcon />}
							>
								Delete Selected
							</Button>}
						</div>

						<EnhancedDataGrid
							rows={this.state.data}
							sx={{
								// Visual disabled state while the row is refetching.
								'& .refetching-invoice-row': {
									opacity: 0.55,
									cursor: 'not-allowed',
									filter: 'grayscale(0.25)',
									backgroundColor: 'rgba(0,0,0,0.03)',
								},
								'& .refetching-invoice-row:hover': {
									backgroundColor: 'rgba(0,0,0,0.03)',
								},
								'& .refetching-invoice-row .MuiDataGrid-cell': {
									// Helps the disabled look read clearly.
									color: 'rgba(0,0,0,0.65)',
								},
							}}
							getRowClassName={(params) => {
								const row = params?.row;
								const invoiceDocumentId = row?.invoiceDocumentId;
								const classes = [];

								// When a row is refetching, it should LOOK disabled.
								// (Post-in-progress rows are explicitly excluded from disable behavior.)
								if (invoiceDocumentId && this.isRowLoading(invoiceDocumentId)) {
									classes.push('refetching-invoice-row');
								}

								if (invoiceDocumentId === this.state.activeRowId) {
									classes.push('active-invoice-row');
								}

								return classes.join(' ');
							}}
							disableColumnMenu
							pagination
							title=""
							gridRef={this.mainGridRef}
							pageSize={10}
							{...serverProps}
							setFilterText={(text) => { this.setFilterText(text) }}
							isWeeksToFilterSearchActive={isWeeksToFilterSearchActive}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter([getInvoiceModuleName(this.props.modelDefId), "ManageInvoiceDocuments", "sortModel"], model);
							}}
							sortModel={this.state.sortModel}
							searchCallback={null}
							showSearchTooltip={false}
							footerMessage={''}
							quickFilterDebounceMs={this.state.weeksToFilter === 0 ? null : 1200}
							columns={this.columns}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
							onRowClick={(params, event) => {
								const row = params?.row;
								if (!row) return;

								// Ignore clicks on interactive elements (checkbox, links, buttons)
								const target = event?.target;
								const clickedInteractive =
									(target?.closest && (
										target.closest('a') ||
										target.closest('button') ||
										target.closest('input') ||
										target.closest('.MuiCheckbox-root') ||
										target.closest('.MuiDataGrid-checkboxInput')
									));
								if (clickedInteractive) return;

								const invoiceId = row?.invoiceDocumentId;
								const isPostInProgress = this.isPostInProgressRow(row);
								const isLoading = !!invoiceId && this.isRowLoading(invoiceId) && !isPostInProgress;
								if (isLoading) return; // disabled while refetching

								if (this.isPartiallyPostedRow(row)) {
									this.openPartialPostDialogForRow(row);
								} else {
									this.openEditorFromRow(row);
								}
							}}
							options={{
								showTextRowsSelected: false,
								selection: true,
								selectionProps: rowData => {
									// Disable selection while a row is refetching (except Post In Progress).
									const loadingIds = this.state.loadingRowIds || [];
									const isLoading = loadingIds.includes(rowData.invoiceDocumentId);
									const isPostInProgress = this.isPostInProgressRow(rowData);

									const postStatus = (rowData.invoicePostStatus || '').toLowerCase();
									const isPosted =
										(postStatus.includes('posted') && postStatus !== 'post in progress') ||
										rowData.invoiceDocumentStatusId === 170;

									const isEligibleToSelect = rowData.approvalLinkText === "Post to ERP System";

									return {
										disabled: (isLoading && !isPostInProgress) || isPosted || (!isLoading && !isEligibleToSelect),
										color: 'default'
									};
								},
								showSelectAllCheckbox: false,
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 670
							}}
							customcomponent={
								<>
									<Button
										key={1}
										variant="contained"
										color="inherit"
										onClick={this.newInvoice_clickHandler}
										size="medium"
										style={{ float: "right", zIndex: 1, marginLeft: 10, marginTop: 7, display: (this.props.modelDefId === 3 ? "none" : "") }}
										startIcon={<PostAddIcon />}
									>
										Create New Invoice
									</Button>
									{this.getWeeksToFilterDropDown(this.state.filterText)}
									{this.getSearchButton()}
								</>
							}
							onSelectionChange={(rows) => {
								const postToERPSystem = "Post to ERP System";
								const repostToERPSystem = "Repost to ERP System";
								const readyToPost = "Ready to Post";

								const invalidForPost = rows.filter(x =>
									x.approvalLinkText !== postToERPSystem &&
									x.approvalLinkText !== repostToERPSystem &&
									x.approvalLinkText !== readyToPost
								);
								let canPerformAction = true;
								if (invalidForPost.length === 0) {
									if (!this.state.postCreditMemo && rows.some(row => { return row.applyToInvoiceDocumentId > 0; })) {
										canPerformAction = false;
									}
									if (!this.state.repostRuleEditable && rows.some(row => { return row.applyToInvoiceDocumentId <= 0; })) {
										canPerformAction = false;
									}
								}



								this.setState({
									showBulkPostToERP: rows.length > 0 && invalidForPost.length === 0 && canPerformAction,
									selectedRows: rows
								});
							}}

							data={this.state.data}
						/>
					</div>
				</div>

				{
					this.state.openInvoiceDocumentEditorDialog &&
					<Dialog open={this.state.openInvoiceDocumentEditorDialog} TransitionComponent={Transition} fullScreen>
						<InvoiceDocumentEditor
							info={info}
							clientInfo={clientInfo}
							partialSelectedRows={this.state.mode === "UserEntry" ? null : this.state.partialSelectedRows}
							onClose={this.invoiceDocumentEditor_closeHandler}
							fetchDashboard={(gadgetNo, weeks) => { }}
						/>
					</Dialog>
				}

				{this.state.openPartialPostDialog && (
					<InvoiceDocumentPartialPostLookup
						invoiceDocumentId={this.state.partialPostInvoiceDocumentId}
						canEdit={this.state.repostRuleEditable}
						onEdit={(selectedRows) => {
							// Partial Post Edit is a VIEW-variant mode.
							// Only selected seqIds will be editable in the details grid.
							const row = this.state.data.find(
								r => r.invoiceDocumentId === this.state.partialPostInvoiceDocumentId
							);

							this.setState(
								{ openPartialPostDialog: false },
								() => {
									this.openEditorFromRow(row, {
										modeOverride: 'PartialPost',
										partialSelectedRows: selectedRows
									});
								}
							);
						}}
						mode={this.state.partialPostDialogMode}
						modelDefId={this.props.modelDefId}
						inProgress={this.props.inProgress}
						onClose={(shouldRefresh = false) => {
							const invoiceId = this.state.partialPostInvoiceDocumentId;
							this.setState(
								{
									openPartialPostDialog: false,
									partialPostInvoiceDocumentId: null,
									partialPostDialogMode: 'view',
								},
								() => {
									if (shouldRefresh && invoiceId) {
										this.refreshRowViaListApi(invoiceId, { setActive: true });
									}
								}
							);
						}}
						onView={() => {
							const row = this.state.data.find(
								r => r.invoiceDocumentId === this.state.partialPostInvoiceDocumentId
							);

							this.setState(
								{ openPartialPostDialog: false },
								() => {
									this.openEditorFromRow(row, {
										modeOverride: Constants.VIEW
									});
								}
							);
						}}
					/>
				)}

				<Dialog open={this.state.openBulkDeleteConfirmation}>
					<DialogTitle>Delete Invoices</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure, you want to delete the selected invoice(s)?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.bulkDeleteYes} color="error">
							Yes
						</Button>
						<Button onClick={() => this.setState({ openBulkDeleteConfirmation: false })}>
							No
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={this.state.openCreditMemoRepostDialog}
					onClose={() => this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null })}
					TransitionComponent={Transition}
				>
					<DialogTitle>Rescan Original Invoice</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Do you want to rescan the original invoice as well?
						</DialogContentText>
					</DialogContent>
					<DialogActions>

						<Button
							onClick={async () => {
								const row = this.state.creditMemoRowForRepost;
								const creditMemoId = row?.invoiceDocumentId;
								const originalInvoiceId = row?.applyToInvoiceDocumentId;

								if (!creditMemoId) return;
								this.props.inProgress(true);
								try {

									if (originalInvoiceId > 0) {
										await httpPost("/api/invoicedocument/rescanoriginalinvoice", {
											companyCode: this.companyCode,
											modelDefId: this.props.modelDefId,
											applyToInvoiceDocumentId: originalInvoiceId
										});
										toast.success('Invoice sent for rescan');
									}
									this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null });
								}
								catch {
									toast.error('Rescaning invoice failed');
								}
								this.props.inProgress(false);
							}}
						>
							Yes
						</Button>
						<Button
							onClick={async () => {
								this.setState({ openCreditMemoRepostDialog: false, creditMemoRowForRepost: null });
							}}
						>
							Cancel
						</Button>
					</DialogActions>
				</Dialog>



			</div>
		);
	}
}